import { DeleteAccountMessages, TranslationDeleteAccountMessages } from "@languages/interfaces";

export const messages: TranslationDeleteAccountMessages = {
  [DeleteAccountMessages.stepOne]: "Delete my Topcon Customer account",
  [DeleteAccountMessages.description]: `Deleting your account will permanently remove your access to Topcon Customer, 
  and this action cannot be undone, and to access again you will need to create a new user. To continue with the 
  deletion, follow the steps below:`,
  [DeleteAccountMessages.stepTwo]: "Confirm account deletion",
  [DeleteAccountMessages.stepThree]: "Enter your Topcon Customer password",
  [DeleteAccountMessages.deleteButton]: "Delete my account",
  [DeleteAccountMessages.checkConfirmDeletion]: `I want to
  delete all my account data, including my user, schedules, contracts, invoices, approvals, reports and permissions
  and others.`,
  [DeleteAccountMessages.deleteAccountFailed]: "Failed to delete account"
};